import { TextareaInput } from 'components/ui/TextareaInput/TextareaInput';
import { TextInput } from 'components/ui/TextInput/TextInput';
import { NOOP } from 'constants/index';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

const WAIT_TIME = 250;

export const TextInputField = ({
  field,
  handleBlur = NOOP,
  handleChange = NOOP,
}) => {
  const {
    autoComplete = 'off',
    defaultValue,
    error,
    format,
    hint,
    id,
    label,
    placeholder,
    readOnly,
    required,
  } = field;

  if (format === 'text') {
    return (
      <TextareaInput
        autoComplete={autoComplete}
        error={error}
        hint={hint}
        label={label}
        name={id}
        onBlur={name => setTimeout(() => handleBlur(name), WAIT_TIME)}
        onChange={debounce(handleChange, WAIT_TIME)}
        placeholder={placeholder}
        readOnly={readOnly}
        value={defaultValue}
        required={required}
      />
    );
  }

  return (
    <TextInput
      error={error}
      hint={hint}
      label={label}
      name={id}
      onBlur={name => setTimeout(() => handleBlur(name), WAIT_TIME)}
      onChange={debounce(handleChange, WAIT_TIME)}
      placeholder={placeholder}
      readOnly={readOnly}
      value={defaultValue}
      required={required}
    />
  );
};

TextInputField.propTypes = {
  field: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
};
